<div [formGroup]="parts" *ngIf="isReady">

<input type="text"  placeholder="Vendedor" aria-label="Vendedor" matInput   formControlName="selectedId" [matAutocomplete]="vendorAutoComplete">

<mat-autocomplete #vendorAutoComplete="matAutocomplete" [displayWith]="displayVendorFn">
  <mat-option *ngFor="let vendor of vendorOptions | async" [value]="vendor">
    {{ vendor.name }}
  </mat-option>
</mat-autocomplete>

</div>